import { render } from "./IconComponent.vue?vue&type=template&id=ebb7caf8"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/IconComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebb7caf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebb7caf8', __exports__)) {
    api.reload('ebb7caf8', __exports__)
  }
  
  module.hot.accept("./IconComponent.vue?vue&type=template&id=ebb7caf8", () => {
    api.rerender('ebb7caf8', render)
  })

}


export default __exports__